import { render, staticRenderFns } from "./ModalInsuranceContacts.vue?vue&type=template&id=59463c1e&"
import script from "./ModalInsuranceContacts.vue?vue&type=script&lang=js&"
export * from "./ModalInsuranceContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports